export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Pinned-Gray-2f2a0479f806ea79a5dcf3ad7a44e899.svg";